import { render } from "./TaiXeCauHangCard.vue?vue&type=template&id=6a84e7ec&scoped=true"
import script from "./TaiXeCauHangCard.vue?vue&type=script&lang=js"
export * from "./TaiXeCauHangCard.vue?vue&type=script&lang=js"

import "./TaiXeCauHangCard.vue?vue&type=style&index=0&id=6a84e7ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a84e7ec"]])

export default __exports__